var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget",staticStyle:{"height":"408px"}},[_c('v-card-text',{staticClass:"pa-0"},[_c('line-chart-with-area',{attrs:{"dataSet":_vm.weeklySales,"lineTension":0.5,"dataLabels":_vm.labels,"width":370,"height":80,"enableXAxesLine":_vm.enableXAxesLine,"color":_vm.ChartConfig.color.primary}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }